import { apiClient, ApiClientResponse } from '../services/api-client';

export type IdentityDocumentValidationStatus = 'clear' | 'listed' | 'invalid' | 'skipped' | 'PROVIDER_ERROR';

export type IdentityDocumentValidationRequest = {
  identification: string;
  documentNumber: string;
  country?: 'CZ' | 'SK';
};

export type IdentityDocumentValidationResponse = {
  status: IdentityDocumentValidationStatus;
};

const identityDocumentValidationApi = {
  create: (
    payload: IdentityDocumentValidationRequest,
  ): Promise<ApiClientResponse<IdentityDocumentValidationResponse>> =>
    apiClient.post('/identity-document-validation', payload),
};

export default identityDocumentValidationApi;
